import { FC } from 'react';
import { PortfolioAccountItem } from 'model/modules/portfolio/accounts';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { ButtonVariant } from 'presentation/theme/components/button';
import AppRoute from 'router/AppRoute';
import sharesproMark from 'assets/img/logos/sharespro-mark-green.svg';

interface Props {
  account: PortfolioAccountItem;
}

const WithdrawalRequestCard: FC<Props> = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <AppCard
        minH="130px"
        p="15px"
        display="flex"
        justifyContent="space-between"
        bgImage="linear-gradient(180deg, #848484 0%, #323232 100%)"
        bgColor={Color.Primary500}
        {...props}
      >
        <Flex flexDirection="column" justifyContent="space-between">
          <Box>
            <Text mb="10px" color="white" fontSize="18px" fontWeight={700}>
              {t('analyticsWithdrawal')}
            </Text>
            <Text maxW="240px" mb="24px" color="white">
              {t('leaveWithdrawalRequestPlease')}
            </Text>
          </Box>
          <Flex
            display="flex"
            justifyContent="space-between"
            direction="row"
            gap={15}
          >
            {
              props.account.service.isAllowWithdraw
                ? <Button
                  variant={ButtonVariant.Light}
                  onClick={() => navigate(AppRoute.createWithdrawalOrder(props.account.id))}
                >
                  {t('leaveRequest')}
                </Button> : null
            }

            {
              props.account.hasWithdrawRequest ? <Button
                variant={ButtonVariant.LightOutlined}
                onClick={() => navigate(AppRoute.withdrawalOrders(props.account.id))}
              >
                {t('viewWithdrawalRequests')}
              </Button> : null
            }
          </Flex>
        </Flex>
        <Image src={sharesproMark} h="100px" w="100px" objectFit="contain" />
      </AppCard>
    </>
  );
};

export default WithdrawalRequestCard;
